module.exports = __webpack_public_path__ + "img/5.0269d7e6.png";